const TOGGLE_SIDEBAR_MINI = "TOGGLE_SIDEBAR_MINI";

export const toggleSidebarMini = () => ({
  type: TOGGLE_SIDEBAR_MINI
});

const initialState = {
  isSidebarMini: false
};

export default function sidebarReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR_MINI:
      return {
        ...state,
        isSidebarMini: !state.isSidebarMini
      };
    default:
      return state;
  }
}
